"use client";

import { useAnimate, useReducedMotion } from "framer-motion";
import { type ReactNode, useEffect } from "react";

import { tileFlyInConfig } from "@/lib/animations";

function randomFlyInParams() {
  return {
    delay: Math.random() * tileFlyInConfig.staggerWindow,
    x: (Math.random() - 0.5) * tileFlyInConfig.xRange,
    y: (Math.random() - 0.5) * tileFlyInConfig.yRange,
  };
}

interface FlyInTileProps {
  children: ReactNode;
  className?: string;
}

export function FlyInTile({ children, className }: FlyInTileProps) {
  const prefersReduced = useReducedMotion();
  const [scope, animate] = useAnimate<HTMLDivElement>();

  useEffect(() => {
    if (!scope.current) return;
    if (prefersReduced) {
      animate(scope.current, { opacity: 1 }, { duration: 0 });
      return;
    }
    const { delay, x, y } = randomFlyInParams();
    animate(scope.current, { scale: tileFlyInConfig.scale, x, y }, { duration: 0 }).then(() => {
      if (!scope.current) return;
      animate(
        scope.current,
        { opacity: 1, scale: 1, x: 0, y: 0 },
        { ...tileFlyInConfig.transition, delay }
      );
    });
  }, [animate, prefersReduced, scope]);

  return (
    <div ref={scope} className={className} style={{ opacity: 0 }}>
      {children}
    </div>
  );
}
